import { useState, useEffect, useCallback } from 'react';
import useApi from '../../../utils/useApi';
import { API_CONFIG } from './apiConfig';

export const useDashboardData = ({ preset, startDate, endDate } = {}) => {
  const [lastUpdated, setLastUpdated] = useState(null);

  const [fetchOverview, overviewInfo] = useApi({
    method: API_CONFIG.methods.get,
    url: API_CONFIG.endpoints.overview,
  });

  const loadData = useCallback(() => {
    if (preset === 'custom' && (!startDate || !endDate)) {
      return;
    }

    const params = { preset: preset || 'today' };
    if (preset === 'custom') {
      params.startDate = startDate;
      params.endDate = endDate;
    }

    fetchOverview({
      params,
      onCompleted: (res) => {
        if (res && res.data) {
          setLastUpdated(new Date());
        }
      },
    });
  }, [preset, startDate, endDate]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return {
    data: overviewInfo.data,
    isLoading: overviewInfo.loading,
    hasErrors: Boolean(overviewInfo.error),
    error: overviewInfo.error,
    refresh: loadData,
    lastUpdated,
  };
};
